import {Component, OnInit} from '@angular/core';
import {UserService, User} from '../user.service';
import {Router} from '@angular/router';
import {AppSettingsService} from '../app-settings.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  name: String;

  isCollapsed = true;
  menuState = true;

  constructor(private us: UserService, private router: Router, public ass: AppSettingsService) {

    Observable.fromEvent(window, 'resize')
      .subscribe(event => {
        this.adjustMenuState();
      });
  }

  adjustMenuState() {
    this.ass.menuState.next(!this.needKeepClosed(window.innerWidth));
  }

  ngOnInit() {
    this.us.currentUser.subscribe((user: User) => {
      if (user) {
        this.name = user.name;
      } else {
        this.name = 'Error';
      }
    });

    this.ass.menuState.subscribe((menuState: boolean) => {
      this.menuState = menuState;
    });
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleMenu() {
    this.ass.menuState.next(!this.menuState);
  }

  logout() {
    this.us.logout();
    this.router.navigateByUrl('/login');
  }

  needKeepClosed(width: number): boolean {
    console.log(`KeepClosed:${width < 768}`)
    return (width < 768);
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/header/header.component.ts